import React from 'react'
import Button, { ButtonType } from '../../Button'
import Icon, { IconType } from '../../Icon'
import componentStyle from './AnnouncementsAlert.module.scss'
import styles from '@bt-react/styles'
import { AnnouncementsAlertProps } from './../types'

const AnnouncementsAlert: React.FC<AnnouncementsAlertProps> = ({ announcementText, onConfirm, onCancel }) => {

  return <div className={ componentStyle['announcements-announcementsalert-container']} data-bdd="announcements-announcementsalert-container">
    <div className={ componentStyle['announcementsalert-sec']}>
      <div className={` ${styles['row']} ${componentStyle['alert-sec']} `}>
        <div className={` ${styles['col-1']} ${componentStyle['alert-icon']} `}>
          <Icon name={ IconType.iconName.danger } colour={IconType.colour.white} />
        </div>
        <div className={` ${styles['col-11']} ${componentStyle['alert-message']} `}>
          <div>The following announcement will be displayed to your live audience:</div>
          <div className={ styles['mt-3'] }><strong>{announcementText}</strong></div>
        </div>
      </div>
      <div className={componentStyle['alert-confirm-msg']}>
        Are you sure you want to continue?
      </div>
      <div className={ componentStyle['alert-buttons']}>
        <Button
          type={ ButtonType.buttonType.button }
          onClick={onConfirm}
          text="Yes, display now"
          data-bdd="announcement-alert-confirm"
          className={ componentStyle['button'] }
        />
        <Button
          type={ ButtonType.buttonType.button }
          onClick={onCancel}
          text="Cancel"
          color={ IconType.colour.link}
          className={ `${componentStyle['button']} ${styles['ml-3']}` }
          data-bdd="announcement-alert-cancel"
        />
      </div>
    </div>
  </div>

}

export default AnnouncementsAlert
